import React from 'react';

const GeneralHeader = ({ headerText }) => (
  <h3 className="h3">{ headerText }</h3>
);

export default GeneralHeader;
